export function parseTextWithLinks(text, maxLength = 20) {
  const urlRegex = /https?:\/\/[^\s]+/g;
  const parts = [];
  let lastIndex = 0;

  const matches = [...text.matchAll(urlRegex)];

  for (const match of matches) {
    const url = match[0];
    const index = match.index;

    // Push any text before the match
    if (index > lastIndex) {
      parts.push({ type: 'text', content: text.slice(lastIndex, index) });
    }

    // Remove query string for display
    const displayUrl = url.split('?')[0];
    let shortened = displayUrl;

    if (displayUrl.length > maxLength) {
      const domain = new URL(displayUrl).hostname.replace(/^www\./, '');
      const path = new URL(displayUrl).pathname;
      const truncated = path.length > 10 ? `${path.slice(0, 6)}...${path.slice(-4)}` : path;
      shortened = `${domain}${truncated}`;
    }

    parts.push({
      type: 'link',
      content: shortened,
      href: url,
    });

    lastIndex = index + url.length;
  }

  // Push any text after the last URL
  if (lastIndex < text.length) {
    parts.push({ type: 'text', content: text.slice(lastIndex) });
  }

  return parts;
}
